import styled from "styled-components";
import { spacingL, spacingS, spacingXL } from "@RooUI";

export const TextContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${spacingXL};
  margin-top: ${spacingXL};
  div {
    text-align: left;
  }
  h6 {
    margin-top: ${spacingS};
  }
`;

export const ErrorContainer = styled.div`
  margin-top: -${spacingL};
`;
